import { Col, Icon, Row, Upload } from "antd";
import React from "react";
import { useImportStatementFormContext } from "../context";
import { ContainerUploadFile } from "./styles";

// import { Container } from './styles';

function StepUploadFile() {
  const { fileList, selectFile } = useImportStatementFormContext();
  const props = {
    accept: ".ofx",
    listType: "picture",
    onRemove: (file) => {
      selectFile([]);
    },
    beforeUpload: (file) => {
      selectFile([file]);
      return false;
    },
    showUploadList: {
      showPreviewIcon: false,
      showDownloadIcon: false,
    },
    fileList,
  };
  return (
    <ContainerUploadFile>
      <Row type="flex">
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <p className="message">
            Selecione o arquivo de extrato no formato <strong>.OFX</strong>.
          </p>
        </Col>
      </Row>
      {/* Upload area */}
      <div className="uploadRow">
        <Upload.Dragger {...props}>
          {fileList.length > 0 ? (
            <>
              <p className="ant-upload-drag-icon">
                <Icon type="file-excel" />
              </p>
              <p className="ant-upload-text">{fileList[0].name}</p>
            </>
          ) : (
            <>
              <p className="ant-upload-drag-icon">
                <Icon type="inbox" />
              </p>
              <p className="ant-upload-text">
                Arraste-e/solte ou selecione manualmente
              </p>
            </>
          )}
        </Upload.Dragger>
      </div>
    </ContainerUploadFile>
  );
}

export default StepUploadFile;
